export const ENVIRONMENT: string =
  process.env.REACT_APP_ENVIRONMENT || "production";

export const FLIPPER_API_URL: string =
  process.env.REACT_APP_FLIPPER_API_URL || "flipper.walrus.com";

/**
 * Build configuration
 *
 * BUILD_VERSION determines which landing page version to display.
 *
 * Available versions:
 * - "A": Standard version with GLP-1 journey focus
 * - "BLACK_FRIDAY": Special promotional version with $40 reward offer
 *
 * Set via environment variable:
 * - BUILD_VERSION=A npm start
 * - BUILD_VERSION=BLACK_FRIDAY npm start
 *
 * Or in .env file:
 * REACT_APP_BUILD_VERSION=BLACK_FRIDAY
 */
export const BUILD_VERSION: string = process.env.REACT_APP_BUILD_VERSION || "A";

export const GOOGLE_ANALYTICS_ID: string =
  process.env.REACT_APP_GOOGLE_ANALYTICS_ID || "";
